import styled from 'styled-components';

import { type LinkVariation } from 'types';

export const LinkWrapper = styled.span<{ variation: LinkVariation }>(({ theme, variation }) => ({
  ...(variation === 'blue' && {
    color: theme.styleguideColors.contentBlue,
    '& > *': {
      color: theme.styleguideColors.contentBlue,
    },
    '&:hover > *': {
      color: theme.styleguideColors.fillPrimaryRed,
    },
    '&:active > *': {
      color: theme.styleguideColors.fillPrimaryRedClick,
    },
  }),
}));

export const HistoryLinkWrapper = styled.span(({ theme }) => ({
  color: theme.styleguideColors.contentBlue,
  '& > *': {
    color: theme.styleguideColors.contentBlue,
  },
  '&:hover > *': {
    color: theme.styleguideColors.fillPrimaryRed,
  },
  '&:active > *': {
    color: theme.styleguideColors.fillPrimaryRedClick,
  },
}));
